angular.module('tgaAdmin').controller('HubThemeController', [
  '$scope',
  '$state',
  '$filter',
  '$location',
  '$uibModal',
  'hubService',
  '$translate',
  function ($scope, $state, $filter, $location, $uibModal, hubService, $translate) {
    $scope.showBack = $state.current.data.back;

    $scope.data = {
      alerts: [],
      hubId: $state.params.hub_id || null,
      themes: [
        {
          theme_id: 1,
          name: 'Theme 1',
          color_1: '#e52828',
          color_2: '#36d900',
          color_3: '#0036d9',
          color_4: '#ffffff',
        },
        {
          theme_id: 2,
          name: 'Theme 2',
          color_1: '#d900d9',
          color_2: '#00d9d9',
          color_3: '#ff9326',
          color_4: '#ffffff',
        },
        {
          theme_id: 0,
          name: 'Custom',
          color_1: '#ffffff',
          color_2: '#ffffff',
          color_3: '#ffffff',
          color_4: '#ffffff',
        },
      ],
    };

    $scope.viewmodel = {
      hub_id: $state.params.hub_id,
      theme_id: null,
      theme: {},
      background: null,
      logo: null,
    };

    $scope.initialize = function () {
      $scope.loading = true;

      hubService.getHub($scope.data.hubId).then((hub) => {
        $scope.viewmodel = { ...$scope.viewmodel, ...hub };

        if (hub.theme_id === 0) {
          $scope.actions.addCustomTheme($scope.viewmodel.theme);
        }

        $scope.title = `<span class="text-muted">Arcades / ${hub.name} /</span> Theme`;
        $scope.loading = false;
      });
    };

    $scope.actions = {
      submit(form) {
        $scope.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $scope.processing = true;

        hubService.updateTheme($scope.viewmodel).then(
          () => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Arcade updated.', 'success');
            $scope.initialize();
            $scope.processing = false;
          },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            $scope.processing = false;
          },
        );
      },
      selectTheme() {
        const theme = $scope.data.themes.filter((t) => t.theme_id === $scope.viewmodel.theme_id);

        $scope.viewmodel.theme = angular.copy(theme[0]);
      },
      addCustomTheme(theme) {
        theme.name = 'Custom';
        $scope.data.themes[2] = { ...$scope.data.themes[2], ...theme };
      },
      checkImage(image) {
        if (!image) {
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        const extension = /(?:\.([^.]+))?$/;
        const ext = extension.exec(image.filename)[1];
        const allowed = /jpeg|jpg|gif|png|svg/i;
        if (!allowed.test(ext)) {
          image.base64 = null;
          image = null;
          $scope.actions.createAlert('<span class="fa fa-exclamation-triangle"></span> Invalid file format.', 'danger');
          return;
        }

        // Don't allow images larger than 5MB.
        if (image.filesize > 5242880) {
          image.base64 = null;
          image = null;
          $scope.actions.createAlert(
            '<span class="fa fa-exclamation-triangle"></span> Image files cannot be more than 5 MB in size.',
            'danger',
          );
        }
      },
      forceHex(color) {
        const theme = $scope.data.themes.filter((t) => t.theme_id === $scope.viewmodel.theme_id);

        if ($scope.viewmodel.theme[color] !== theme[0][color]) {
          $scope.viewmodel.theme_id = 0;
          $scope.viewmodel.theme.theme_id = 0;
          $scope.actions.addCustomTheme($scope.viewmodel.theme);
        }

        if ($scope.viewmodel.theme[color].length && $scope.viewmodel.theme[color][0] !== '#') {
          $scope.viewmodel.theme[color] = `#${$scope.viewmodel.theme[color]}`;
        }
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
